#import "../fragments/email-stats-fragment.graphql"

query GetEmailStats {
    emailStats {
        ...EmailStats
    }
}
